import React from "react";
import clsx from "clsx";
import { createUseStyles } from "react-jss";
import arrowUp from "../../assets/arrowUp@2x.png";

const GotoTop: React.FC<{ goTo: () => void; isScroll: boolean, endScroll?: boolean, bottomButtonSize?: number }> = ({ goTo, isScroll, endScroll = false, bottomButtonSize = 0 }) => {
  const useStyles = createUseStyles(() => ({
    wrap: {
      position: "fixed",
      width: "100%",
      height: 0,
      bottom: 46,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      opacity: 0,
      left: -9999,
      transitionDelay: "0.3s",
      "&.active": {
        opacity: 1,
        left: 0,
        transitionDelay: "0s",
      }
    },
    goto: {
      width: 47,
      height: 47,
      borderRadius: "50%",
      background: `url(${arrowUp}) center center no-repeat`,
      backgroundSize: "21px 21px",
      backgroundColor: "#FFF",
      boxShadow: "0px 3px 15px 0px rgba(0, 0, 0, 0.14)",
      opacity: 0,
      transition: "all 0.3s",
      "&.active": {
        opacity: 1,
        transition: "all 0.3s",
      }
    },
    endScroll: {
      transform: `translateY(-${bottomButtonSize}px)`,
    },
  }));
  const classes = useStyles();
  return (
    <div className={clsx(classes.wrap, isScroll && "active")}>
      <div className={clsx(classes.goto, isScroll && "active", (endScroll && !!bottomButtonSize) && classes.endScroll)} onClick={goTo}>
      </div>
    </div>
  )
}

export { GotoTop }